import PropTypes from "prop-types"
import React, { useEffect } from "react"

import { Route, Routes } from "react-router-dom"
import { connect, useSelector } from "react-redux"

// Import Routes all
import { userRoutes, authRoutes } from "./routes/allRoutes"

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware"

// layouts Format
import VerticalLayout from "./components/VerticalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"

// Import scss
import "./assets/scss/theme.scss"
// import "./assets/scss/colorTheme.scss";

// Import Firebase Configuration file
// import { initFirebaseBackend } from "./helpers/firebase_helper"

// Import Fack Backend
import fakeBackend from "./helpers/AuthType/fakeBackend"
import { createSelector } from "reselect"
import { Helmet } from "react-helmet"
// Make all modals draggable by their header (one global delegated handler)
import { enableModalDragging } from "./helpers/modalDrag"

// Activating fake backend
fakeBackend()

// const firebaseConfig = {
//   apiKey: process.env.REACT_APP_APIKEY,
//   authDomain: process.env.REACT_APP_AUTHDOMAIN,
//   databaseURL: process.env.REACT_APP_DATABASEURL,
//   projectId: process.env.REACT_APP_PROJECTID,
//   storageBucket: process.env.REACT_APP_STORAGEBUCKET,
//   messagingSenderId: process.env.REACT_APP_MESSAGINGSENDERID,
//   appId: process.env.REACT_APP_APPID,
//   measurementId: process.env.REACT_APP_MEASUREMENTID,
// }

// init firebase backend
// initFirebaseBackend(firebaseConfig)

const selectLoginState = state => state.Login
const LoginProperties = createSelector(selectLoginState, login => ({
  loggedUser: login.loggedUser,
}))

/**
 * Calyvern brand themes. Same CSS-variable keys, palette swapped:
 *   blue — accent #2F57C4 (cube top), deep #0C36A5
 *   grey — accent #565C66 (cube left), ink #23272E
 * Returns the full var map to apply on :root.
 */
const applyBrandTheme = theme => {
  const blue = {
    accent: "#2F57C4", deep: "#0C36A5",
    soft: "#E4EDFF", softer: "#E7EFFF", focus: "#CEDEFF", hover: "#D4E2FF",
    chip: "#D9E5FF", uploadBg: "#F5F9FE", uploadBr: "#C0D0F1", borderNo: "#D8E1F2",
  }
  const grey = {
    accent: "#565C66", deep: "#3A3F49",
    soft: "#EEF0F3", softer: "#E6E8EC", focus: "#D7DBE0", hover: "#DFE3E8",
    chip: "#E1E4E8", uploadBg: "#F6F7F8", uploadBr: "#CBD0D6", borderNo: "#D5D8DD",
  }
  const p = theme === "grey" ? grey : blue
  return {
    "--primary": "transparent",
    "--accent-clr": p.accent,
    "--btnDark": p.accent,
    "--tbl-head": p.accent,
    "--tbl-body": "#7E879A",
    "--text-extra-high": p.accent,
    "--menu-avtive-txt": p.accent,
    "--backarrow-color": p.accent,
    "--file-txt": p.accent,
    "--chart-label": p.accent,
    "--icon-clr": p.accent,
    "--accord-clr": p.accent,
    "--calender-main": p.accent,
    "--calender-selected": p.accent,
    "--menu-avtive": p.soft,
    "--border": p.softer,
    "--export-btn": p.softer,
    "--inner-tbl": p.soft,
    "--multi-input": p.soft,
    "--calender-primary": p.soft,
    "--calender-dark": p.soft,
    "--inrange-clr": p.soft,
    "--note-background": p.soft,
    "--input-focus": p.focus,
    "--select-hover": p.hover,
    "--chart-light": p.chip,
    "--file-upload-bg": p.uploadBg,
    "--file-upload-br": p.uploadBr,
    "--border-no": `1px solid ${p.borderNo}`,
    "--input-disable": "#F4F4F4",
    "--placeholder": "#7E879A",
    "--sec-btn": "#FFB703",
  }
}

/** Swap the browser favicon set to match the selected brand theme (blue / grey). */
const setThemeFavicons = theme => {
  const pub = process.env.PUBLIC_URL || ""
  document
    .querySelectorAll('link[rel~="icon"], link[rel="apple-touch-icon"]')
    .forEach(l => l.remove())
  ;[
    { rel: "icon", href: `${pub}/brand/${theme}/favicon.ico`, sizes: "any" },
    { rel: "icon", type: "image/png", sizes: "32x32", href: `${pub}/brand/${theme}/favicon-32.png` },
    { rel: "icon", type: "image/png", sizes: "16x16", href: `${pub}/brand/${theme}/favicon-16.png` },
    { rel: "apple-touch-icon", sizes: "180x180", href: `${pub}/brand/${theme}/apple-touch-icon-180.png` },
  ].forEach(attrs => {
    const link = document.createElement("link")
    Object.entries(attrs).forEach(([k, v]) => link.setAttribute(k, v))
    document.head.appendChild(link)
  })
}

const App = props => {
  const { loggedUser } = useSelector(LoginProperties)
   const imgUrl = process.env.REACT_APP_IMG_APIKEY

  // Dynamic meta description and image
  const metaDescription =
    loggedUser?.settings?.companyinfo ||
    "EverRise by iTrobes"
  const metaImage =
    loggedUser?.settings?.companyfavicon
      ? `${imgUrl}${loggedUser.settings.companyfavicon}`
      : "/meta-logo-500.png"
  const favicon =
    loggedUser?.settings?.mob_svg
      ? `${imgUrl}${loggedUser.settings.mob_svg}`
      : "/favicon1.png"
      const titleTag = loggedUser?.settings?.companyname || "MEP by iTrobes"

    const themeCheck = localStorage?.getItem("themeManage")

  useEffect(() => {
    // The saved Application Settings theme is authoritative; fall back to the
    // in-app theme switcher (themeManage) only when no saved theme exists.
    const opt = loggedUser?.settings?.theme_option || themeCheck
    // Conditionally import color theme based on loggedUser's theme setting
    if (opt == 1) {
      import("./assets/scss/colorTheme.scss")
    } else if (opt == 2 || opt == 3) {
      // Calyvern brand themes: 2 = Blue, 3 = Grey. Same variable keys, palette swapped.
      const theme = opt == 3 ? "grey" : "blue"
      const palette = applyBrandTheme(theme)
      Object.entries(palette).forEach(([k, v]) =>
        document.documentElement.style.setProperty(k, v)
      )
      setThemeFavicons(theme)
      // Guarantee primary buttons follow the theme with a LITERAL colour (some
      // nested var() chains don't resolve on .btn-primary across browsers).
      const accent = palette["--accent-clr"]
      let ov = document.getElementById("theme-overrides")
      if (!ov) { ov = document.createElement("style"); ov.id = "theme-overrides"; document.head.appendChild(ov) }
      ov.textContent =
        `.btn-primary,.tnt-scope .btn-primary{background-color:${accent}!important;border-color:${accent}!important;--bs-btn-bg:${accent};--bs-btn-border-color:${accent};--bs-btn-hover-bg:${accent};--bs-btn-hover-border-color:${accent};--bs-btn-active-bg:${accent};}`
    }
  }, [loggedUser?.settings?.theme_option, themeCheck])
  function getLayout() {
    let layoutCls = VerticalLayout

    switch (props.layout.layoutType) {
      default:
        layoutCls = VerticalLayout
        break
    }
    return layoutCls
  }

  // enable drag-by-header on every modal, app-wide (runs once)
  useEffect(() => { enableModalDragging() }, [])

  const Layout = getLayout()
  return (
    <React.Fragment>
      <Helmet>
        <meta name="description" content={metaDescription} />
        <meta property="og:image" content={metaImage} />
        <link rel="icon" href={favicon} />
        <title>{titleTag}</title>
      </Helmet>
      <Routes>
        {authRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={<NonAuthLayout>{route.component}</NonAuthLayout>}
            key={idx}
            isAuthProtected={false}
          />
        ))}

        {userRoutes.map((route, idx) => (
          <Route
            path={route.path}
            element={
              <Authmiddleware>
                {route.path == "/network-error" ? (
                  <div>{route.component}</div>
                ) : (
                  <Layout>{route.component}</Layout>
                )}
              </Authmiddleware>
            }
            key={idx}
            isAuthProtected={true}
            exact
          />
        ))}
      </Routes>
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any,
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}

export default connect(mapStateToProps, null)(App)
